import { createRoot } from 'react-dom/client';
import React from 'react';
import { ProductMatchingBikeSelection } from 'PyzShopUi/scripts/product-detail-page/components/ProductMatchingBikeSelection';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import IReactEvent from 'PyzShopUi/scripts/interfaces/article-list/IReactEvent';
import { BikeSelectEvent } from 'PyzShopUi/scripts/react/common/events/bikeSelectEvent';
import ProductVariantDataHandler from 'PyzShopUi/scripts/product-detail-page/includes/productVariantData';
import { ISelectOption } from 'PyzShopUi/scripts/shop-ui/interfaces';

const bikeVariantDropDownSelector = '.bike-variant-dropdown[data-type="bike-search"]';

export default class ProductMatchingBikeSelectionWidget {
    private static rootMap = new Map();

    public static init = (articleMainInfoElement: HTMLElement, initFunction: () => void = () => { }): void => {

        const bikeVariantDropDown: HTMLElement = articleMainInfoElement.querySelector(bikeVariantDropDownSelector);
        if (bikeVariantDropDown) {
            const bikeMatchingProductsData = getBikeMatchingProductsData(bikeVariantDropDown);
            renderProductMatchingBikeSelection(bikeMatchingProductsData);
        }

        MiddlewareEventBus.getInstance().subscribe((event: IReactEvent<any>) => {
            if (event.type !== BikeSelectEvent.SELECT_SEARCH_SUGGEST_BIKE
                && event.type !== BikeSelectEvent.SELECT_MY_BIKE) {
                return;
            }

            renderProductMatchingBikeSelection(event.payload);
        });

        function getBikeMatchingProductsData(bikeVariantDropDown: HTMLElement) {
            const bikeMatchingProducts: any[] = bikeVariantDropDown.dataset.bikeMatchingProducts ?
                JSON.parse(bikeVariantDropDown.dataset.bikeMatchingProducts) : [];

            if (!bikeMatchingProducts || !bikeMatchingProducts.length) {
                return;
            }

            const bikeExternalId: string = bikeVariantDropDown.dataset.bikeExternalId ?
                bikeVariantDropDown.dataset.bikeExternalId : "";
            const activeConcreteId: string = bikeVariantDropDown.dataset.concreteId;

            const productVariantData = ProductVariantDataHandler.init();
            const concreteName = (option): string => productVariantData[option.value]?.fullName;

            return {
                options: bikeMatchingProducts.map((option): ISelectOption[] => {
                    if (!option.label) {
                        option.label = concreteName(option);
                    } else {
                        option.label = `${concreteName(option)} [${option.label}]`;
                    }
                    if (option.value === activeConcreteId) {
                        option.selected = true;
                    }
                    return option;
                }),
                bikeCode: bikeExternalId,
                domEntryElement: bikeVariantDropDown,
            };
        }

        function createRootWrapper(domNode) {
            if (!ProductMatchingBikeSelectionWidget.rootMap.has(domNode)) {
                const root = createRoot(domNode);
                ProductMatchingBikeSelectionWidget.rootMap.set(domNode, root);
            }
            return ProductMatchingBikeSelectionWidget.rootMap.get(domNode);
        }

        function renderProductMatchingBikeSelection(bikeMatchingProductsData: any) {
            if (!bikeMatchingProductsData) {
                return;
            }

            const radioDropdownRoot = document.querySelector('.bike-variant-dropdown[data-type="my-bike"]');
            const searchBoxDropDownRoot = document.querySelector('.bike-variant-dropdown[data-type="bike-search"]');
            let options

            if (bikeMatchingProductsData.options !== null) {
                options = [...bikeMatchingProductsData.options];
                options.unshift({ value: '', label: '', disabled: true });
            }

            const props = { key: bikeMatchingProductsData.bikeCode, options, onNoRedirect: initFunction }

            createRootWrapper(searchBoxDropDownRoot).render(
                <ProductMatchingBikeSelection
                    {...props}
                    display={bikeMatchingProductsData.domEntryElement.dataset.type === "bike-search"}
                />
            );

            createRootWrapper(radioDropdownRoot).render(
                <ProductMatchingBikeSelection
                    {...props}
                    display={bikeMatchingProductsData.domEntryElement.dataset.type === "my-bike"}
                />
            );
        }
    }
}
